import { render, staticRenderFns } from "./SuggestedTags.vue?vue&type=template&id=45a432ed&"
import script from "./SuggestedTags.vue?vue&type=script&lang=js&"
export * from "./SuggestedTags.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedTags.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports